import React, { useState } from 'react';
import { List, ListItemButton, ListItemText } from '@mui/material';

import { enqueueError } from '@paragon/notification-tools';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { associateTrussEnvelopesWithExistingComponentDesign } from '../../store/actions/layout/trussEnvelopeActions';
import { SelectComponentDesignDialogProps } from '../../store/actions/popupActions';
import { getNaturalSortedComponentDesigns } from '../../store/selectors/getSortedComponentDesignsSelectors';
import { useAppDispatch, useAppSelector } from '../hooks';

export function SelectComponentDesignDialog(props: SelectComponentDesignDialogProps) {
  const dispatch = useAppDispatch();
  const componentDesigns = useAppSelector(getNaturalSortedComponentDesigns);

  const [isWorking, setIsWorking] = useState(false);

  return (
    <Dialog
      title="Select Component Design"
      variant="design"
      onCancel="close"
      disabled={isWorking}
      hasSpinner={isWorking}
    >
      <List sx={{ maxHeight: '70vh' }}>
        {componentDesigns.map((design) => (
          <ListItemButton
            key={design.guid}
            onClick={async () => {
              switch (props.continuation.type) {
                case 'associate-with-envelope':
                  setIsWorking(true);

                  try {
                    await dispatch(
                      associateTrussEnvelopesWithExistingComponentDesign(
                        props.continuation.trussEnvelopeGuids,
                        design.guid,
                      ),
                    );
                  } catch (error) {
                    console.error(error);
                    dispatch(enqueueError('Unable to associate component design with truss envelope.'));
                  } finally {
                    setIsWorking(false);
                    dispatch(closeCurrentPopup());
                  }
                  break;

                default:
                  assertExhaustiveSwitch(props.continuation.type);
              }
            }}
          >
            <ListItemText primary={design.component.name} />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}
